// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"309":"54b82283","524":"f8f70c83","774":"c237fa4b"}[chunkId] + ".chunk.js";
};